import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-curve-shape-short",
  "use": "icon-curve-shape-short-usage",
  "viewBox": "0 0 1459.1 205",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1459.1 205\" id=\"icon-curve-shape-short\"><path d=\"M1459 148.4c-103.3 18.3-251.4 19.8-251.4 19.8-166.4 3.3-336.9-14-336.9-14 67.3 11.7 182.1 28.1 330.8 32 149.1 4 257.6-9.7 257.6-9.7v22.8s-126.6 13.9-375.7-1.9C812.9 180.3 626.9 109.6 415 68.1 196 25.2 0 37.2 0 37.2V0h1459.1l-.1 148.4zM0 55.9s75.2-9.6 192.4-1.5C295.3 61.5 398 83.5 398 83.5s-96.1-12.7-206.5-13.6C80.9 68.9 0 79.4 0 79.4V55.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol